import { useUpdateDemarrage } from '@teetsh/app/src/containers/Demarrage/queries/useUpdateDemarrage';
import { StepWrapper } from '@teetsh/app/src/containers/Demarrage/components/StepWrapper';
import { useDemarrage } from '@teetsh/app/src/containers/Demarrage/queries/useDemarrage';
import { SelectCards } from 'components/Form/SelectCards';
import _isEmpty from 'lodash-es/isEmpty';
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'twin.macro';
import { Role } from 'types/user';

export function DirectorAccess() {
  const update = useUpdateDemarrage();
  const { t } = useTranslation(['onboarding']);

  const { data: demarrageData } = useDemarrage();

  const options: Array<{
    label: string;
    value: Role;
    description: string;
  }> = [
    {
      label: t('onboarding:directorAccess.choiceDirector'),
      description: t('onboarding:directorAccess.choiceDirectorDescription'),
      value: 'director',
    },
    {
      label: t('onboarding:directorAccess.choiceTeacher'),
      description: t('onboarding:directorAccess.choiceTeacherDescription'),
      value: 'teacher',
    },
  ];

  return (
    <StepWrapper
      currentStep="directeur-access"
      nextDisabled={_isEmpty(demarrageData?.roles)}
      title={t('onboarding:directorAccess.title')}
    >
      <p tw="mb-6">{t('onboarding:directorAccess.subtitle')}</p>
      <SelectCards<Role, true>
        isMulti
        size="big"
        value={demarrageData?.roles || []}
        onChange={async roles => {
          await update({ roles });
        }}
        options={options}
        direction="vertical"
      />
    </StepWrapper>
  );
}
